import axios from "axios";

export const api = axios.create({
  baseURL: 'https://my-local-theatre-server.onrender.com'
});